import { httpV1 as http } from '../api';

export async function findOne(key) {
  return http.get(`/shared/cache/${key}`);
}

export async function deleteBy(key) {
  return http.delete(`/shared/cache/${key}`);
}
